import { Box } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { useContext } from 'react'

import { MinterEventBox } from '../../../Components'
import { MinterEventsContext } from '../../../Contexts'

interface Props {
  entity?: EthAddress
  quadkey?: Quadkey
}

const EventsList: React.FC<Props> = (props) => {
  const { quadkey } = props
  const { events } = useContext(MinterEventsContext)
  return (
    <Box display="flex" flexDirection="column">
      <Box display={events?.length ? 'flex' : 'none'} flexDirection="column">
        {events?.map((event, index) => {
          return <MinterEventBox event={event} id={quadkey} key={index} />
        })}
      </Box>
    </Box>
  )
}

export default EventsList
